import isElem from '../../scripts/util/isElement';
import $ from 'jquery';

const selectors = {
	inputWithPlaceholder: '.js--input-with-placeholder'
};

const inputChangePlaceholder = () => {
	$(selectors.inputWithPlaceholder).find('input').on('focus', function () {
		$(this).closest(selectors.inputWithPlaceholder).addClass('is--focus');
	});

	$(selectors.inputWithPlaceholder).find('input').on('blur', function () {
		if ($(this).val() === '') {
			$(this).closest(selectors.inputWithPlaceholder).removeClass('is--focus');
		}
	});
};

const render = () => {
	if (isElem(selectors.inputWithPlaceholder)) {
		inputChangePlaceholder();
	}
};

export default render;
